<button
  type="button"
  class="theme-switcher grid h-12 w-12 shrink-0 place-items-center rounded-md bg-secondary text-foreground-50 max-sm:h-9 max-sm:w-9"
  [class.checked]="isDark()"
  (click)="onSwitchClick($event)"
  [attr.aria-pressed]="isDark()"
  [attr.aria-label]="isDark() ? 'Switch to light theme' : 'Switch to dark theme'"
>
  <span class="theme-switcher__icon">
    <span class="theme-switcher__icon-part theme-switcher__icon-part--1"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--2"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--3"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--4"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--5"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--6"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--7"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--8"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--9"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--10"></span>
    <span class="theme-switcher__icon-part theme-switcher__icon-part--11"></span>
  </span>
  <span class="theme-switcher__sr">{{ isDark() ? 'Dark Mode' : 'Light Mode' }}</span>
</button>
